import React from 'react'
import {FormattedMessage, injectIntl} from 'react-intl'
import {missingTranslation} from "../ajax"
import substringAfterLastDot from "./substringAfterLastDot";

const InjectMessage = props => {
    let {id, intl} = props
    const translate = typeof id == "string" && id.startsWith("$")
    if (!translate) {
        return (id || "")
    }

    let p = {...props}
    id = id.substring(1)
    if (id && typeof intl.messages[id] == "undefined") {
        const general_str = 'general.' + substringAfterLastDot(id)
        if (intl.messages[general_str]) {
            id = general_str
        } else {
            missingTranslation(id)
        }
    }
    p.id = id
    return <FormattedMessage {...p} />
}

export default injectIntl(InjectMessage, {
    withRef: false
})
